<template lang="pug">
#e_insurance
  custom-header(
    :title="policyDownload.area01_Title",
    :subTitle="policyDownload.area01_SubTitle",
    :image="policyDownload.area01_Image",
    :buttonName="policyDownload.area01_ButtonName",
    :buttonURL="policyDownload.area01_ButtonURL"
  )

  section.container.custom_container_sm.i_mt_16.i_pb_10
    h2.i_h2_title.text-center {{ policyDownload.area02_Title }}
    p.i_content(v-html="policyDownload.area02_StepHtml")
    //- p.i_content {{ policyDownload.area02_BottomTitle }}
    //- p.i_content.device.i_ml_4.d-inline-block 電腦
    //- .download.i_content.d-block.d-md-inline-block
    //-   a.i_ml_4(
    //-     v-for="(downLoad, index) in policyDownload.area02_Bottom_PC_DownloadList",
    //-     :key="index",
    //-     :href="downLoad.area02_Bottom_DownloadList_URL",
    //-     target="_blank",
    //-     :class="[{ 'd-block': index == policyDownload.area02_Bottom_PC_DownloadList.length - 1 }, { 'd-md-inline-block': index == policyDownload.area02_Bottom_PC_DownloadList.length - 1 }]"
    //-   ) {{ downLoad.area02_Bottom_DownloadList_Title }}
    //- br
    //- p.i_content.device.i_ml_4.d-inline-block 手機
    //- .download.i_content.d-block.d-md-inline-block.i_ml_4
    //-   a.i_mr_7.i_mr_sm_4(
    //-     v-for="(downLoad, index) in policyDownload.area02_Bottom_MOBILE_DownloadList",
    //-     :key="index",
    //-     :href="downLoad.area02_Bottom_DownloadList_URL",
    //-     target="_blank",
    //-     :class="[{ 'd-block': index == policyDownload.area02_Bottom_MOBILE_DownloadList.length - 1 }, { 'd-md-inline-block': index == policyDownload.area02_Bottom_MOBILE_DownloadList.length - 1 }]"
    //-   ) {{ downLoad.area02_Bottom_DownloadList_Title }}
    //- .qr_code.i_ml_15.i_ml_md_13.d-none.d-md-block
    //-   img(:src="policyDownload.area02_Bottom_QRcode01")
    //-   img.i_ml_4.i_ml_md_3(:src="policyDownload.area02_Bottom_QRcode02")
  section
    expand-head.i_mt_6(
      @click.native="setRelatedQuesExpand",
      :title="relatedQuesTitle",
      :icon="'ic_QA_compensation'",
      :selected="relatedQuesExpand"
    )
    transition(name="fade-height")
      .container(v-show="relatedQuesExpand")
        .related_ques_content(
          v-for="(QuestionContent, index) in currentQAList",
          :key="index"
        )
          qa-html-item.i_pt_6(:QuestionContent="QuestionContent")
        .row
          .col-12.text.center.justify-content-center
            b-pagination(
              v-model="currentPage",
              :total-rows="totalRows",
              :per-page="perPage",
              first-number,
              last-number
            )
  .container.i_mt_6.i_mb_10
    router-link.btn_round(v-if="true",tag="a", :to="{ name: 'CustomerServiceContactUs' }") 聯絡我們

  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getEPolicyDownload } from "@/json/customer_service";
import { getFAQDetail } from "@/json/FAQ";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import QAHtmlItem from "@/components/customer_service/QAHtmlItem";
import ExpandHead from "@/components/common/ExpandHead";

export default {
  name: "CustomerServiceEInsurance",
  metaInfo() {
    return {
      title: this.policyDownload.SEO_Title,
      meta: [
        { name: "description", content: this.policyDownload.SEO_Description },
      ],
    };
  },
  components: {
    "custom-header": CustomHeader,
    "dedicated-line": DedicatedLine,
    "qa-html-item": QAHtmlItem,
    ExpandHead,
  },
  data() {
    return {
      policyDownload: {},
      FAQDetail: [],
      relatedQuesTitle: "保險內容相關問題",
      relatedQuesExpand: true,
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      currentQAList: [],
      QAList: [],
    };
  },
  created() {
    this.getEPolicyDownload();
  },
  watch: {
    currentPage() {
      this.getCurrentQAList();
    },
  },

  methods: {
    getEPolicyDownload() {
      getEPolicyDownload().then((response) => {
        this.policyDownload = response.data;
        this.totalRows = response.data.area03_FAQList.length;
        getFAQDetail().then((response) => {
          this.FAQDetail = response.data.FAQDeatilList;
          this.getQAList();
        });
      });
    },
    getQAList() {
      this.QAList = [];
      for (let x in this.policyDownload.area03_FAQList) {
        let temp = this.policyDownload.area03_FAQList[x];
        for (let y in this.FAQDetail) {
          let detail = this.FAQDetail[y];
          if (temp.FAQDeatilID == detail.FAQID) {
            this.QAList.push(detail);
            break;
          }
        }
      }
      this.getCurrentQAList();
    },
    getCurrentQAList() {
      this.currentQAList = [];
      let number = this.perPage * this.currentPage;
      this.currentQAList = this.QAList.slice(number - this.perPage, number);
    },
    setRelatedQuesExpand() {
      this.relatedQuesExpand = !this.relatedQuesExpand;
    },
    expand() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/customer_service/e_insurance";
</style>
